import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import RouteLoader from "./components/RouteLoader";
import { AuthProvider } from "./contexts/AuthContext";
import RequireAdmin from "./components/admin/RequireAdmin";

// Route-level code splitting: each page only downloads when a visitor
// actually navigates to it, instead of shipping every page in one bundle.
const Home = lazy(() => import("./components/Home"));
const Tuition = lazy(() => import("./components/Tuition"));
const Blog = lazy(() => import("./components/Blog"));
const BlogPost = lazy(() => import("./components/BlogPost"));
const Mission = lazy(() => import("./components/Mission"));
const Mentors = lazy(() => import("./components/pages/Mentors"));
const Ethos = lazy(() => import("./components/pages/Ethos"));
const PersonalStatement = lazy(() => import("./components/pages/PersonalStatement"));
const CVSupport = lazy(() => import("./components/pages/CVSupport"));
const Socials = lazy(() => import("./components/pages/Socials"));
const GetInvolved = lazy(() => import("./components/pages/GetInvolved"));
const FAQ = lazy(() => import("./components/pages/FAQ"));
const NotFound = lazy(() => import("./components/NotFound"));
const AdminLogin = lazy(() => import("./components/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./components/admin/AdminDashboard"));
const AdminPostEditor = lazy(() => import("./components/admin/AdminPostEditor"));

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Navigation />
            <main className="main-content">
              <Suspense fallback={<RouteLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tuition" element={<Tuition />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:id" element={<BlogPost />} />
                  <Route path="/mission" element={<Mission />} />

                  {/* New routes */}
                  <Route path="/mentors" element={<Mentors />} />
                  <Route path="/ethos" element={<Ethos />} />
                  <Route path="/personal-statement" element={<PersonalStatement />} />
                  <Route path="/cv-support" element={<CVSupport />} />
                  <Route path="/socials" element={<Socials />} />
                  <Route path="/get-involved" element={<GetInvolved />} />
                  <Route path="/faq" element={<FAQ />} />

                  {/* Blog admin - login is public, everything else requires an admin session */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route element={<RequireAdmin />}>
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/posts/new" element={<AdminPostEditor />} />
                    <Route path="/admin/posts/:id/edit" element={<AdminPostEditor />} />
                  </Route>

                  {/* Catch-all */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
